import { render } from "./djRebateList.vue?vue&type=template&id=4660ac8c&scoped=true"
import script from "./djRebateList.vue?vue&type=script&lang=js"
export * from "./djRebateList.vue?vue&type=script&lang=js"

import "./djRebateList.vue?vue&type=style&index=0&id=4660ac8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4660ac8c"

export default script